<template lang="html">
	<div class="omapi-feature">
		<div class="omapi-feature-content">
			<div class="omapi-feature__description">
				<h3>Add recommended business solutions to my site</h3>
				<button id="plugin-toggle" @click="togglePluginWrap">
					<span class="sr-only">Toggle Plugins</span>
				</button>
			</div>
			<label class="omapi-checkbox">
				<input
					ref="input"
					type="checkbox"
					name="allExtraFeatures"
					:checked="shouldBeChecked"
					@input="setValue"
				/>
				<span class="omapi-checkbox__input"></span>
			</label>
		</div>
	</div>
</template>

<script lang="js">
import { createNamespacedHelpers } from 'vuex'
import { defaultState } from './../store/state';
const { mapState } = createNamespacedHelpers('wizard')

export default {
	computed : {
		...mapState([ 'extraFeatures' ]),
		/**
		 * Get the default extra features from state.
		 *
		 * @returns {Array} The default extra features.
		 */
		defaultExtraFeatures() {
			const defaults = defaultState();
			return defaults.extraFeatures;
		},
		/**
		 * Determine if the "select all" checkbox should be checked.
		 *
		 * @returns {boolean} True if the checkbox should be checked.
		 */
		shouldBeChecked () {
			// If the current extra features matches the length of the default, then
			// every plugin has been selected.
			return this.defaultExtraFeatures.length === this.extraFeatures.length;
		},
	},
	methods : {
		/**
		 * Set the value of extraFeatures array.
		 *
		 * If the checkbox is checked, then set the value to the
		 * default extra features. Otherwise, set the value to an empty array.
		 *
		 * @param {Object} event The event object.
		 *
		 * @returns {void}
		 */
		setValue (event) {
			const payload = event.target.checked ? this.defaultExtraFeatures : [];

			this.$store.commit('wizard/resetExtraFeatures', payload);
		},
		/**
		 * Toggle the "active" class for the given element.
		 *
		 * @param {Object} element The element to toggle.
		 *
		 * @returns {void}
		 */
		toggleActive(element) {
			if (element.classList.contains('active')) {
				element.classList.remove('active');
			} else {
				element.classList.add('active');
			}
		},
		/**
		 * Show or hide the list of plugins.
		 *
		 * @param {Object} event The event object.
		 *
		 * @returns {void}
		 */
		togglePluginWrap(event) {
			const pluginWrap = document.getElementById('all-plugins-wrap');

			this.toggleActive(pluginWrap);
			this.toggleActive(event.target);
		}
	},
};
</script>
<style lang="scss" scoped>
.omapi-feature {
	border: 1px solid #f1f1f1;
	border-left: none;
	border-right: none;
	.omapi-feature-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		.omapi-feature__description {
			display: inline;

			h3 {
				display: inline-block;
			}

			#plugin-toggle {
				display: inline-block;
				position: relative;
				background: transparent;
				border: none;
				margin-left: 10px;
				padding: 0;

				&:hover {
					cursor: pointer;
				}

				&:before {
					content: url('./../../assets/images/icons/expand-more.svg');
					border: none;
					display: block;
					transform: rotate(180deg);
				}

				&.active:before {
					transform: rotate(0deg);
				}
			}
		}
		.omapi-checkbox {
			display: inline;
			border: none !important;
		}
	}
}
</style>
